module.exports = __webpack_public_path__ + "img/gemxx.370ffc1c.png";